import { useRoute, useRouter } from '#imports'
import { computed } from 'vue'

import { ROUTE_NAMES } from '~/constants/routes'

export function useKybNavigation() {
  const router = useRouter()
  const route = useRoute()

  const isReviewStep = computed(
    () => route.name === ROUTE_NAMES.ONBOARDING.KYB.STEPS.REVIEW,
  )

  const handleGoBack = () => {
    const previousPath = router.options.history.state.back

    if (
      typeof previousPath === 'string' &&
      previousPath.startsWith(
        router.resolve({ name: ROUTE_NAMES.ONBOARDING.KYB.INDEX }).path,
      )
    ) {
      router.back()
    } else {
      router.push({ name: ROUTE_NAMES.ONBOARDING.KYB.STEPS.STEP_1 })
    }
  }

  return {
    isReviewStep,
    handleGoBack,
  }
}
